var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7591 16.081C20.3996 16.5003 19.7683 16.5487 19.349 16.1892L12 9.88738L4.65093 16.1892C4.23168 16.5487 3.60037 16.5003 3.24086 16.081C2.88135 15.6618 2.92978 15.0305 3.34904 14.6709L11.349 7.81095C11.7236 7.48978 12.2764 7.48978 12.6509 7.81095L20.6509 14.6709C21.0702 15.0305 21.1186 15.6618 20.7591 16.081Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronX2);
export default __webpack_public_path__ + "static/media/ChevronX2.b3c9442b50f5b3829f0c63b7b409e383.svg";
export { ForwardRef as ReactComponent };